module.exports = {
	"id": "WS",
	"name": "Samoa",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016628,
			"12": null,
			"13": null,
			"14": 0.08314,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.16628,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.008314,
			"23": null,
			"24": 0.024942,
			"25": 0.04157,
			"26": null,
			"27": null,
			"28": 0.008314,
			"29": 0.016628,
			"30": null,
			"31": 0.024942,
			"32": 0.033256,
			"33": null,
			"34": null,
			"35": 0.016628,
			"36": 0.08314,
			"37": null,
			"38": 0.016628,
			"39": null,
			"40": 0.049884,
			"41": null,
			"42": 0.058198,
			"43": 0.016628,
			"44": 0.058198,
			"45": 0.024942,
			"46": null,
			"47": 0.091454,
			"48": 0.224478,
			"49": 10.35093,
			"50": 0.108082,
			"51": 0.37413,
			"52": 0.565352,
			"53": 24.69258,
			"54": 7.208238,
			"55": 0.133024,
			"56": 0.024942,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.4157,
			"4": 0.116396,
			"5": 0.174594,
			"6": 0.108082,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.12471,
			"11": null,
			"12": 0.04157,
			"13": null,
			"14": null,
			"15": 0.016628,
			"16": 0.04157,
			"17": null,
			"18": 0.074826,
			"19": 1.097448,
			"20": 0.08314,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.008314,
			"27": 0.016628,
			"28": null,
			"29": 0.008314,
			"30": 0.108082,
			"31": 0.024942,
			"32": null,
			"33": 0.08314,
			"34": 0.016628,
			"35": 0.058198,
			"36": 0.016628,
			"37": null,
			"38": 0.307618,
			"39": 0.024942,
			"40": 0.12471,
			"41": null,
			"42": 0.08314,
			"43": 0.407386,
			"44": 0.523782,
			"45": 0.340874,
			"46": null,
			"47": 1.729312,
			"48": 0.947796,
			"49": 11.897334,
			"50": 0.274362,
			"51": null,
			"52": 0.066512,
			"3.5": 0.008314,
			"3.6": 0.074826
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.066512,
			"37": 0.058198,
			"38": null,
			"39": null,
			"40": 0.024942,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.074826,
			"6": null,
			"7": null,
			"8": 0.731632,
			"9": 0.698376,
			"10": 1.513148,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": 0.008314,
			"7.1": null,
			"9.1": 1.280356
		},
		"ios_saf": {
			"8": 0,
			"10": 2.7384458418,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0737979467111,
			"8.1-8.4": 0.136338579517,
			"9.0-9.2": 0.0650422581182,
			"9.3": 0.992311373855
		},
		"android": {
			"3": 0,
			"4": 0.0141197054264,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00176496317829,
			"4.1": 0.0509317945736,
			"4.2-4.3": 0.127329486434,
			"4.4": 0.291975337209,
			"4.4.3-4.4.4": 0.294496713178
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.798144,
			"9": 1.862336,
			"10": 0.74826,
			"11": 7.490914,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0263935215092,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000733153375255
		},
		"edge": {
			"12": 0.16628,
			"13": 1.313612,
			"14": 1.139018
		},
		"ie_mob": {
			"10": 0.00631656338028,
			"11": 0.0257174366197
		},
		"bb": {
			"7": 0.0332985,
			"10": null
		},
		"samsung": {
			"0": 2.247438
		},
		"and_uc": {
			"0": 1.227408
		},
		"op_mini": {
			"0": 0.355595325116
		},
		"and_chr": {
			"0": 8.79362
		},
		"and_ff": {
			"0": 0.010116
		}
	},
	"total": 99.4559745
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/WS.json
 ** module id = 683
 ** module chunks = 0
 **/